import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { Tenant } from 'src/types/tenant'

interface TenantState {
  currentTenant: Tenant
  setCurrentTenant: (tenant: Tenant) => void
  clear: () => void
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      currentTenant: {} as Tenant,
      setCurrentTenant: (tenant) => set({ currentTenant: tenant }),
      clear: () => set({ currentTenant: {} as Tenant }),
    }),
    {
      name: 'tenant-store',
      // use to prevent affecting other tabs when switching tenants
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
